<template>
  <Select :options="fieldOptions" v-model="field" @changeValue="changeValue('field', $event)" placeholder="Fields" :disabled="disabled" />
</template>

<script>
import DefaultPackage from './DefaultPackage.vue'
export default {
  extends: DefaultPackage,
  data() {
    return {
      field: ''
    }
  },
  computed: {
    value() {
      return this.config.value
    },
    fieldOptions() {
      return Object.entries(this.packages?.[this.config?.parentPackage]?.fields || {}).reduce((result, [key, value]) => {
        result.push({
          id: key,
          text: value.label
        })
        return result
      }, [])
    }
  },
  watch: {
    value: {
      handler(values) {
        this.field = values?.field
      },
      immediate: true
    }
  }
}
</script>
